module.exports = __webpack_public_path__ + "img/doctor_logout_icon.12b7432e.png";